module.exports = __webpack_public_path__ + "static/img/040奥丁投票.d60e9d1.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/picImgs/040奥丁投票.jpg
// module id = TOEX
// module chunks = 0